import { render, staticRenderFns } from "./Initiate.vue?vue&type=template&id=1ea8e090&scoped=true"
import script from "./Initiate.vue?vue&type=script&lang=js"
export * from "./Initiate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8e090",
  null
  
)

export default component.exports